import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { Box, IconButton } from "@mui/material";
import { useContext, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Flex from "../components/Flex";
import DraggableContainer from "../components/draggable/DraggableContainer";
import { maximize, minimize } from "../redux/feature/join-room/JoinRoomSlice";
import { RootState, store } from "../redux/store";
import { getPatientVisitNoteUrl } from "../utils/utils";
import JoinRoom from "./JoinRoom";
import { ZoomContext } from "./zoom-context";
import { useUpdateAppointmentStatus } from "../queries/use-change-appointment-status";
import { getViewAs, getStoredRealm } from "@/utils/auth-storage";

/**
 * @description To Manage Join Room With Drag & (PIP) feature
 *
 * @author Rajkumar Rathod
 *
 */
const DraggableJoinRoom = () => {
  const isMinimize: boolean = useSelector(
    (state: RootState) => state?.joinRoom?.isMinimize
  );

  return (
    <DraggableContainer
      isFullScreen={!isMinimize}
      initialPosition={{ x: 20, y: 590 }}
      width={isMinimize ? "400px" : "100%"}
      height={isMinimize ? "334px" : "100%"}
    >
      <Box height={"100%"} width={"100%"} boxSizing={"border-box"}>
        <ActionController />
        <JoinRoom />
      </Box>
    </DraggableContainer>
  );
};

export default DraggableJoinRoom;

const ActionController = () => {
  const zmClient = useContext(ZoomContext);
  const isMinimize = useSelector(
    (state: RootState) => state.joinRoom.isMinimize
  );

  return (
    <Flex
      gap={1}
      sx={{
        position: "absolute",
        top: zmClient?.isHost() && !isMinimize ? 90 : 20,
        right: 20,
      }}
    >
      <ActionButton isMinimize={isMinimize} />
    </Flex>
  );
};

const ActionButton = ({ isMinimize }: { isMinimize?: boolean }) => {
  const navigate = useNavigate();
  const isFirstClick = useRef(true);
  const viewAs = getViewAs();

  const handleNavigateStartEncounter = () => {
    if (isFirstClick.current) {
      isFirstClick.current = false;

      if (viewAs === "provider")
        navigate(
          getPatientVisitNoteUrl(
            store.getState().joinRoom.patientId,
            store.getState().joinRoom.appointmentId
          )
        );
      // navigate(
      //   `${appPaths.ENCOUNTER}?patientid=${
      //     store.getState().joinRoom.patientId
      //   }&appointmentid=${store.getState().joinRoom.appointmentId}`
      // );
      else if (viewAs === "patient") {
        navigate(-1);
      }
    }

    return minimize();
  };

  const { mutateAsync: updateStatus } = useUpdateAppointmentStatus();

  return (
    <IconButton
      style={{
        zIndex: 999,
        padding: 0,
        backgroundColor: isMinimize ? "#36454F" : "white",
        color: isMinimize ? "white" : "black",
        borderRadius: "50%",
        height: "50px",
        width: "50px",
        margin: "0px",
      }}
      onClick={() => {
        updateStatus({
          appointmentId:
            store.getState().joinRoom.appointmentId?.toString() ?? "",
          status: "IN_EXAM",
          xTENANTID: getStoredRealm() ?? undefined,
        });

        store.dispatch(
          isMinimize ? maximize() : handleNavigateStartEncounter()
        );
      }}
    >
      {isMinimize ? (
        <FullscreenOutlinedIcon fontSize="medium" />
      ) : (
        <RemoveOutlinedIcon fontSize="medium" />
      )}
    </IconButton>
  );
};
